<template> </template>
<script>
/**
 * アラート・モーダルUI VUEコンポーネント
 */
export default {
    data() {
        return {
            isLoading: false,
            loader: null
        }
    },

    methods: {
        /**
         * ローディングを表示
         * @returns {void}
         */
        setLoading: function() {
            this.loader = this.$loading.show({
                container: null,
                canCancel: true,
                onCancel: this.onCancel
            })
            return this.loader
        },

        /**
         * ローディングを終了
         * @returns {void}
         */
        removeLoading: function() {
            if (this.loader) this.loader.hide()
        },

        /**
         * アラートを表示
         * @param {string} str 表示する文字列
         * @param {string} type One of success, info, warning, error, default
         * @returns {void}
         */
        showAlert: function(str, type) {
            this.$toast.open({
                type: type ? type : 'success', //One of success, info, warning, error, default
                position: 'top-right',
                message: str,
                duration: 10000
            })
        },

        /**
         * アラートを表示（success表示）
         * @param {string} str 表示する文字列
         * @returns {void}
         */
        showAlertSuccess: function(str) {
            this.showAlert(str, 'success')
        },

        /**
         * アラートを表示（error表示）
         * @param {string} str 表示する文字列
         * @returns {void}
         */
        showAlertErr: function(str) {
            this.showAlert(str, 'error')
        },

        /**
         * モーダルダイアログを表示
         * @param {string} str 表示する文字列
         * @returns {void}
         */
        showDialog: function(str, title, size) {
            const options = {}
            if (title) {
                options.title = title
            }
            if (size && (size == 0 || size == 2)) {
                options.size = size == 0 ? 'sm' : size == 2 ? 'lg' : null
            }
            return this.$dialogs.confirm(str, options)
        }
    },

    mounted: async function() {}
}
</script>
<style>
.v-dialog {
    margin: 0;
    padding: 0;
    min-height: 100%;
}
.v-dialog-container {
    margin: 2rem;
}
.v-dialog-container .v-dialog-btn {
    color:#4d994d;
    font-weight: bold;
}
.v-dialog-container .v-dialog-btn.v-dialog-btn-danger {
    font-weight: lighter;
}
</style>
<style>
.notices .toast{
    margin: 1rem;
}
</style>

